module.exports = __webpack_public_path__ + "img/illus-01.6bdc0ae8.svg";